import {VehiclePhotoResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export function getVehicleCoverPhoto(
  photos?: VehiclePhotoResponseBody[] | Nullish
): VehiclePhotoResponseBody | null {
  return photos?.find((photo) => photo.isCoverPhoto) ?? null;
}
